
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface Article {
  id: string;
  title: string;
  date: string;
  category_id: string;
  topic: string;
  slug: string;
  publication_state: string;
  category?: {
    name: string;
  };
}

interface ArticleListTableProps {
  articles: Article[];
  categories: Record<string, string>;
  onEdit: (article: Article) => void;
  onDelete: (article: Article) => void;
}

function getPublicationStateBadge(state: string) {
  switch (state) {
    case 'published':
      return <Badge className="bg-green-600 hover:bg-green-700">Published</Badge>;
    case 'archived':
      return <Badge className="bg-gray-600 hover:bg-gray-700">Archived</Badge>;
    default:
      return <Badge className="bg-amber-600 hover:bg-amber-700">Draft</Badge>;
  }
}

export default function ArticleListTable({
  articles,
  categories,
  onEdit,
  onDelete
}: ArticleListTableProps) {
  return (
    <div className="bg-black/20 border border-white/10 rounded-lg shadow overflow-hidden transition-all duration-200">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="text-white">Title</TableHead>
            <TableHead className="text-white">Category</TableHead>
            <TableHead className="text-white">Topic</TableHead>
            <TableHead className="text-white">Date</TableHead>
            <TableHead className="text-white">Status</TableHead>
            <TableHead className="text-white">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {articles.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center py-4 text-gray-300">
                No articles found
              </TableCell>
            </TableRow>
          ) : (
            articles.map((article) => (
              <TableRow key={article.id} className="table-row-hover">
                <TableCell className="font-medium text-white">{article.title}</TableCell>
                <TableCell className="text-gray-300">{categories[article.category_id] || "Unknown"}</TableCell>
                <TableCell className="text-gray-300">{article.topic}</TableCell>
                <TableCell className="text-gray-300">
                  {new Date(article.date).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  {getPublicationStateBadge(article.publication_state)}
                </TableCell>
                <TableCell>
                  <div className="flex space-x-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onEdit(article)}
                      className="border-white/20 hover:bg-white/5 text-white"
                    >
                      Edit
                    </Button>
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={() => onDelete(article)}
                      className="border-white/20"
                    >
                      Delete
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
